import { useQuery } from '@tanstack/react-query';
import { lineItemService } from '@services/lineItem';
import { useAppSelector } from '@redux/hooks';
import type { RootState } from '@redux/store';

export const DISTINCT_LINE_ITEM_UOMS_QUERY_KEY = 'distinctLineItemUnitsOfMeasure';

export const useGetDistinctUnitsOfMeasure = (enabled = true) => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [DISTINCT_LINE_ITEM_UOMS_QUERY_KEY, organizationId],
    queryFn: () => lineItemService.getDistinctUnitsOfMeasure(),
    enabled: !!organizationId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
